<template>
  <span v-if="visible" :class="$attrs.class">
    <slot />
    <ui-time
      v-if="to !== null"
      :class="$style.countdown"
      :value="to"
      :to-ms="true"
      format="future-time-units"
      :timeout="60000"
      clock
      @timeout="onExpired"
    />
  </span>
</template>

<script lang="ts" setup>
import { ref, watch } from 'vue'
import UiTime from '@/ui-core/components/time/index.vue'

defineOptions({ name: 'PickemCountdown', inheritAttrs: false })

const props = defineProps<{
  // Unix-timestamp (секунды), до которого тикает таймер.
  // Внутри ui-time умножается на 1000 благодаря toMs=true.
  to: number | null
}>()

const emit = defineEmits<{
  finish: []
}>()

const isFuture = (timestamp: number | null) =>
  timestamp !== null && timestamp * 1000 > Date.now()

const visible = ref(isFuture(props.to))

watch(
  () => props.to,
  to => {
    visible.value = isFuture(to)
  }
)

const onExpired = () => {
  if (!visible.value) return
  visible.value = false
  emit('finish')
}
</script>

<style lang="scss" module>
.countdown {
  font-variant-numeric: tabular-nums;
}
</style>
